import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { z } from "zod";
import { useAuth } from "@clerk/clerk-react";

export const scamSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string(),
  content: z.string(),
  image: z.string().nullable(),
  icon: z.string(),
  slug: z.string().nullable(),
  // Category fields (nested with id + name, plus flat id)
  scamCategoryId: z.string().optional().nullable(),
  scamCategory: z
    .object({
      id: z.string(),
      name: z.string(),
    })
    .optional()
    .nullable(),
  channels: z.array(z.string()).default([]),
  riskLevel: z.string().nullable().optional(),
  tags: z.array(z.object({ id: z.string(), name: z.string() })).optional().default([]),
  archived: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const getScams = () => {
  const { getToken } = useAuth();
  return useQuery({
    queryKey: ["scams"],
    queryFn: async () => {
      const token = await getToken();
      const response = await axios.get(`${import.meta.env.VITE_API_URL}/app/scams`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return z.array(scamSchema).parse(response.data);
    },
  });
};

export const getScamById = (scamId: string) => {
  const { getToken } = useAuth();
  return useQuery({
    queryKey: ["scam", scamId],
    queryFn: async () => {
      const token = await getToken();
      const response = await axios.get(`${import.meta.env.VITE_API_URL}/app/scams/${scamId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return scamSchema.parse(response.data);
    },
  });
};

export const getScamBySlug = (slug: string) => {
  const { getToken } = useAuth();
  return useQuery({
    queryKey: ["scam", slug],
    queryFn: async () => {
      const token = await getToken();
      const response = await axios.get(`${import.meta.env.VITE_API_URL}/app/scams/slug/${slug}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return scamSchema.parse(response.data);
    },
  });
};